"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _Input = _interopRequireDefault(require("../Input"));
require("react-datepicker/dist/react-datepicker.css");
require("./../../../scss/form-elements/datepickers/react-datepicker-overrides.css");
function DatePicker(_ref) {
  let {
    onChange = null,
    name = 'selectedDate',
    selected = null,
    label = '',
    width = 100,
    helpText = '',
    ...props
  } = _ref;
  const hiddenInput = (0, _react.useRef)(null);
  const [userSelected, setUserSelected] = (0, _react.useState)(selected);
  const defaultOnChange = date => {
    setUserSelected(date);
    if (hiddenInput !== null) {
      hiddenInput.current.value = (0, _format.default)(date, 'yyyy-MM-dd');
    }
  };
  const ExampleCustomInput = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
    let {
      value,
      onClick
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_Input.default, {
      onClick: onClick,
      defaultValue: value,
      label: label,
      width: width,
      showValidation: false,
      helpText: helpText
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: e => {
      if (!e.target.classList.contains('react-datepicker__day')) e.stopPropagation();
    },
    style: {
      display: 'contents',
      '--react-datepicker-wrapper-width': "".concat(width, "%")
    }
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, (0, _extends2.default)({
    onChange: onChange !== null && onChange !== void 0 ? onChange : defaultOnChange,
    selected: userSelected,
    customInput: /*#__PURE__*/_react.default.createElement(ExampleCustomInput, null)
  }, props)), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    ref: hiddenInput,
    name: name
  }));
}
var _default = exports.default = DatePicker;